import type { FrameState } from '@/lib/motion'

import { useEffect, useRef } from 'react'
import { subscribeFrame } from '@/lib/motion'

// Runs a callback on the shared animation loop. Use it to write transforms through refs,
// never to set React state every frame.
export const useFrame = (callback: (state: FrameState) => void, enabled = true): void => {
    const callbackRef = useRef(callback)

    useEffect(() => {
        callbackRef.current = callback
    })

    useEffect(() => {
        if (!enabled) return

        return subscribeFrame(state => callbackRef.current(state))
    }, [enabled])
}
